import { io } from 'socket.io-client';

/**
 * Singleton socket.io-client.
 * autoConnect: false — подключаемся только когда нужно (при загрузке фото).
 * transports: polling сначала — гарантирует работу в Telegram Mini Apps (WKWebView/Android WebView),
 * затем upgrade до WebSocket если доступен.
 */
export const socket = io(window.location.origin, {
    autoConnect: false,
    auth: callback => callback({token: localStorage.getItem('token')}),
    transports: ['polling', 'websocket']
});
window.addEventListener('argus:session', event => {
    if (event.detail.scope === 'staff' && socket.connected) socket.emit('auth:refresh', {token: event.detail.session.accessToken});
});
